import { usePageMeta } from "@/lib/seo";
import { CtaLink } from "@/components/site/primitives";

export default function NotFoundPage() {
  usePageMeta({ title: "Page not found", description: "The page you were looking for could not be found on swastsaathi.in.", path: "/404", noindex: true });
  return (
    <section data-testid="not-found-page" className="relative overflow-hidden bg-mint">
      <div className="dot-grid absolute inset-0 opacity-60" aria-hidden="true" />
      <div className="container-x relative flex min-h-[70vh] flex-col items-start justify-center py-24">
        <img src="/logo-mark.png" alt="" aria-hidden="true" className="h-16 w-auto" />
        <p className="eyebrow mt-10">Error 404</p>
        <h1 className="mt-4 max-w-2xl text-4xl font-semibold leading-[1.05] sm:text-5xl lg:text-6xl">This page is a little too far from home.</h1>
        <p className="mt-6 max-w-lg text-lg leading-relaxed text-slate">The page you were looking for doesn't exist or may have moved. Let's get you back on the right path.</p>
        <div className="mt-10 flex flex-wrap gap-3">
          <CtaLink to="/" testId="not-found-home-cta">Back to home</CtaLink>
          <CtaLink to="/contact" testId="not-found-contact-cta" variant="secondary">Contact SwastSaathi</CtaLink>
        </div>
      </div>
    </section>
  );
}
